module.exports = __webpack_public_path__ + "static/logo-monochrome-1bd1fae511bd58a87f69690fa5883485.png";